import styled from 'styled-components';
const SearchGroupStyled = styled.div`
  /* margin-bottom: 24px; */
  .search-wrapper {
    padding: 32px;
    box-shadow: 0 0 5px 0 rgba(181, 181, 181, 0.26);
    border-radius: 12px;
    background: #ffffff;
    display: flex;
  }
  .left {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  .button-group {
    height: 100%;
    margin-left: 64px;
    display: flex;
    /* flex-direction: column; */
    /* justify-content: space-between;
    align-items: center; */
    .reset {
      /* margin-bottom: 24px; */
      margin-right: 24px;
    }
    .search {
      margin-right: 0;
    }
  }
  .left {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 300ms linear;
    .line {
      display: flex;
      width: 100%;
      transition: all 300ms linear;
      /* border: 1px solid red; */
      gap: 48px;
      > div {
        flex: 1;
      }
    }
  }

  .single-select {
    /* width: 400px; */
    /* height: 56px; */
  }

  .MuiTextField-root {
    /* width: 400px; */
    /* height: 56px; */
  }
`;
export default SearchGroupStyled;
